import React from 'react';
import { ShareSection } from '../../components/template';
const Blog1 = () => {
  // Define different hashtag groups for each section
  
  
  const hashtagsBottom = [
    "#wellnessprograms",    "#holisticwellness",
    "#innertransformation",
    "#rejuvenation",
    "#yoga",
    "#meditation",
    "#ayurveda",

    "#personalgrowth",
    "#stressmanagement",
    "#selfdiscovery",
    "#innerjourney",
    "#holistichealth",
    "#wellnessretreats",
  ];

  const HashtagSection = ({ tags }) => (
    <div className="mt-6 flex flex-wrap md:gap-3 gap-1 justify-center md:mb-6 mb-3">
      {tags.map((tag, index) => (
        <span
          key={index}
          className="bg-light text-red-700 px-4 py-2 rounded-full text-sm font-semibold cursor-pointer transition-all duration-300 m-1  hover:bg-red-700 hover:text-white"
        >
          {tag}
        </span>
      ))}
    </div>
  );

  return (
    <article className="max-w-4xl mx-auto mt-10 px-6 py-4 leading-relaxed">
      {/* Header */}
      <header className="mb-8">
        <h1 className="text-secondary text-4xl font-bold mb-4">
          Why You’re Doing “All the Right Things” — But Still Don’t Feel Alright
        </h1>
        <img
          src="/assets/knowyourself/blogs/blog1/Picture1.png"
          alt="Wellness header"
          className="w-[80%] max-w-xl h-auto max-h-[250px] rounded-lg shadow-md mx-auto object-cover"
        />
      </header>

      {/* Hashtags at the Top */}

      {/* Section 1 */}
      <section className="space-y-4 mb-8">
        <p>Let’s paint a common picture.</p>
        <p>You eat “healthy” (hello, quinoa salad).</p>
        <p>You hit the gym.</p>
        <p>You do 10-minute meditations (when you remember).</p>
        <p>You scroll productivity reels.</p>
        <p>You even do gratitude journaling… once a month.</p>
        <p>
          But deep inside? You're still <strong>tired. distracted. anxious. disconnected.</strong>
          Your energy dips like Mumbai's WiFi during monsoon. You’re trying so hard — but
          something just isn’t clicking.
        </p>
        <p>Why?</p>
        <p className="text-[#578d48] font-semibold">
          Because health isn’t a to-do list.<strong> It’s a way of life.</strong> And most modern wellness
          trends are like trying to fill a leaking pot — one spoon at a time.
        </p>
      </section>

      {/* Section 2 */}
      <section className="space-y-4 mb-8">
        <h2 className="text-primary text-2xl font-semibold">
          💊 The Fragmented Approach is the Real Disease
        </h2>
        <p>Here’s the deal: Modern wellness is broken into a thousand silos.</p>
        <p>Dieticians only talk about carbs and calories.</p>
        <p>Fitness coaches only talk about muscle and reps.</p>
        <p>Therapists focus on past trauma.</p>
        <p>Spirituality folks say, “Just let go.”</p>
        <p className="text-[#578d48] font-semibold">
          But you’re not a body with bolts. You’re not a brain on legs. You’re a complex,
          beautiful, living system with a body, mind, energy, and spirit.<strong> And you need a
          complete system.</strong>
        </p>
      </section>

      {/* Section 3 */}
      <section className="space-y-4 mb-8">
        <h2 className="text-primary text-3xl   font-semibold">
          Introducing: The 4 Pillar Approach of Holistic Well-being
        </h2>
        <p>
          Inspired by the timeless wisdom of <strong>Yoga, Ayurveda, and Positive Psychology,</strong>
          we present to you the full-circle framework to elevate your:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Health</li>
          <li>Focus</li>
          <li>Performance</li>
          <li>Peace</li>
          <li>Purpose</li>
          <li>Prosperity</li>
        </ul>
        <p>In four simple, powerful Sanskrit words:</p>
        <ul className="list-none text-[#578d48] list-inside space-y-1 font-semibold">
          <li>🌱 Vichar | Mindset</li>
          <li>🔥 Achar | Conduct</li>
          <li>🧘‍♂️ Vihar | Recreation</li>
          <li>🥗 Ahar | Diet</li>
        </ul>
      </section>

      {/* Section 4 */}
      <section className="space-y-4 mb-8">
        <h3 className="text-primary text-2xl text-center font-semibold">
          VICHAR – Your Mindset is Your Operating System
        </h3>
        <img
          src="/assets/knowyourself/blogs/blog1/Picture2.png"
          alt="Wellness header"
          className="w-[80%] max-w-xl h-auto max-h-[250px] rounded-lg shadow-md mx-auto object-cover"
        />
        <p>“You become what you think.” — Bhagavad Gita</p>
        <p className="text-[#578d48] font-semibold">
          Your thoughts are not harmless background noise. They are <strong>blueprints</strong>— shaping
          your health, decisions, energy, and success.
        </p>
        <p>
          Most of us have a mental playlist that goes: "I'm not enough." "I'm always
          tired." "I can’t focus." Now imagine your body listening to that… all day. No
          wonder it's confused!
        </p>
        <p><strong>Vichar work </strong>means:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Cultivating positive, empowering beliefs</li>
          <li>Practicing gratitude, affirmations, visualization</li>
          <li>
            Regularly updating your mental apps (aka emotional healing and mindset rewiring)
          </li>
        </ul>
        <p>
          Modern science agrees: Positive psychology shows that optimism, self-belief,
          and meaning in life boost immunity, resilience, and even lifespan.
        </p>
      </section>

      {/* Hashtags in the Middle */}

      {/* Section 5 */}
      <section className="space-y-4 mb-8">
        <h3 className="text-primary text-2xl text-center font-semibold">
          ACHAR – Your Daily Actions Define Your Destiny
        </h3>
        <img
          src="/assets/knowyourself/blogs/blog1/Picture3.png"
          alt="Wellness header"
          className="w-[80%] max-w-xl h-auto max-h-[250px] rounded-lg shadow-md mx-auto object-cover"
        />
        <p>You can’t eat quinoa and still scream at traffic.</p>
        <p className="text-[#578d48] font-semibold">
          Achar is your <strong>conduct, discipline, ethics, and habits</strong> — the way you live.
        </p>
        <p>It includes:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Sleep timing and routine</li>
          <li>Integrity in speech and action</li>
          <li>Non-violence in thought and food</li>
          <li>Aligning your life with values</li>
          <li>Doing the right thing, even when it's not convenient</li>
        </ul>
        <p>
          Ayurveda says: even if you eat sattvic food but live without discipline — you’ll
          stay unwell.
        </p>
        <p>
          This is the <strong>karma </strong>part of wellness. What you repeatedly do — becomes who you are.
        </p>
      </section>

      {/* Section 6 */}
      <section className="space-y-4 mb-8">
        <h3 className="text-primary text-2xl text-center font-semibold">
          VIHAR – Rest, Movement, Rejuvenation
        </h3>
        <img
          src="/assets/knowyourself/blogs/blog1/Picture4.png"
          alt="Wellness header"
          className="w-[80%] max-w-xl h-auto max-h-[250px] rounded-lg shadow-md mx-auto object-cover"
        />
        <p>This one’s usually misunderstood.</p>
        <p className="text-[#578d48] font-semibold">
          Vihar doesn’t just mean "vacation" or exercise. It’s how you <strong>move, play, rest,
          breathe, and recharge.</strong>
        </p>
        <p>Daily Vihar includes:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Conscious movement (yoga, walk, dance, flow)</li>
          <li>Scheduled rest and downtime</li>
          <li>Joyful recreation without screens</li>
          <li>Deep sleep and napping</li>
          <li>Breathwork and pratyahara (sensory rest)</li>
        </ul>
        <p>
        <strong> Your body is not a machine. </strong>It’s a living temple — and even temples need downtime.
        </p>
        <p>Without proper Vihar, your productivity becomes poisonous.</p>
      </section>

      {/* Section 7 */}
      <section className="space-y-4 mb-8">
        <h3 className="text-primary text-2xl text-center font-semibold">
          AHAR – Eat to Nourish, Not Just to Fill
        </h3>
        <img
          src="/assets/knowyourself/blogs/blog1/Picture5.png"
          alt="Wellness header"
          className="w-[80%] max-w-xl h-auto max-h-[250px] rounded-lg shadow-md mx-auto object-cover"
        />
        <p className="text-[#578d48] font-semibold">
          As we covered earlier — food isn’t just calories. It’s<strong> consciousness, emotion,
          and memory.</strong>
        </p>
        <p>Ahar includes:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Eating according to your <strong>prakriti</strong> (Vata, Pitta, Kapha)</li>
          <li>Eating seasonal, sattvic, freshly cooked food</li>
          <li>Eating mindfully, with awareness and gratitude</li>
          <li>Fasting and detox rituals based on your body’s needs</li>
        </ul>
        <p>
        <strong> Your gut is your second brain. </strong>And it’s time we stopped feeding it garbage
          disguised as gourmet.
        </p>
        <p>
          Ahar isn't just about what you eat — it’s about<strong> how, when,</strong> and<strong> why </strong>you eat.
        </p>
      </section>

      {/* Hashtags at the Bottom */}

      {/* Section 8 */}
      <section className="space-y-4 mb-8">
        <h2 className="text-primary text-2xl font-semibold">
          Why This Works (and Why Everything Else Hasn’t)
        </h2>
        <p>
          Because this 4-Pillar system doesn’t try to “fix symptoms.” It transforms the
          foundation.
        </p>
        <p>
          It’s holistic, because it honors the <strong>body, mind, emotions, and soul.</strong> It’s
          time-tested, because it’s drawn from 5,000 years of yogic and Ayurvedic wisdom.
        </p>
        <p>
          It’s science-backed, because positive psychology now proves what Rishis already
          knew.
        </p>
      </section>

      {/* Section 9 */}
      <section className="space-y-4 mb-8">
        <h2 className="text-primary text-2xl font-semibold">
          The Param Promise
        </h2>
        <p>
          This isn’t a trending tip or a quick fix. This is a <strong>soul-level upgrade</strong>.
        </p>
        <p>The 4-Pillar Framework helps you:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Heal the root cause, not the surface symptoms</li>
          <li>Boost mental clarity and willpower</li>
          <li>Align with your unique prakriti and purpose</li>
          <li>Experience true vitality, not just "looking fit"</li>
        </ul>
        <h2 className="text-primary text-2xl font-semibold">
        Ready to Reboot Your Wellness, the Param Way?</h2>
        <p>
           Start by discovering your <strong>current level of Holistic </strong>Wellness with our 5-minute quiz:
        </p>
        <p>
          <a href="/wellness-quiz/holistic-wellness-test" className="text-blue-600 underline">
            👉 Holistic Wellness Quiz Link
          </a>
        </p>
        <p>Let this be your first step to a<strong> whole new YOU.</strong></p>
      </section>

      {/* Section 10 */}
      <section className="space-y-4">
        <h2 className="text-primary text-2xl font-semibold">
          Final Takeaway
        </h2>
        <p>Health is not just green juice. Happiness is not just dopamine hacks.</p>
        <p>
          Prosperity is not just productivity apps. It is <strong>alignment</strong> — between how you
          think, live, move, and eat.
        </p>
        <p>Let the four pillars support your temple. And you’ll realize…</p>
        <p>You were never broken. Just... fragmented.</p>
        <p className="text-[#578d48] font-semibold">
          to wholeness. To wisdom. To Param.
        </p>
      </section>     <HashtagSection tags={hashtagsBottom} />

      <ShareSection/>
    </article>
  );
};

export default Blog1;
